import axios from "axios"
import moment from "moment"
import { apiUrl } from "../utils/Config"
import { observable, action, computed, runInAction } from "mobx"
import { BookingItem, HolderData } from "../records/Booking"

class AccomodationStore {
    rno: string = ""
    channel: string = ""
    availableDates: String[] = []

    getAvailability () {
        axios.get(apiUrl + "/rooms/availability", {
            params: {
                rno: this.rno,
                channel: this.channel,
                dateFrom: moment().subtract(1, "days").format("Y-MM-DD"),
                dateTo: moment().add(12, "months").format("Y-MM-DD")
            }
        }).then((response) => {
            this.availableDates = response.data
        }).catch((error) => {
            console.error(error)
        })
    }

    @observable booking: boolean = true
    @observable step: number = 0
    @observable feePercent: number = 2
    @observable canPay: boolean = false

    @action
    setBooking (booking: boolean) {
        this.booking = booking
    }

    @action
    setStep (step: number) {
        this.step = step
    }

    @action
    stepNext () {
        this.step = this.step + 1
    }

    @action
    stepBack () {
        this.step = this.step - 1
    }

    @action
    setFeePercent (feePercent: number) {
        this.feePercent = feePercent
    }

    @observable checkIn: Date = moment().toDate()
    @observable checkOut: Date = moment().add(3, "days").toDate()
    @observable guests: number = 2

    @action
    setCheckIn (checkIn: Date) {
        this.checkIn = checkIn
    }

    @action
    setCheckOut (checkOut: Date) {
        this.checkOut = checkOut
    }

    @action
    setGuests (guests: number) {
        this.guests = guests
    }

    @observable rooms: BookingItem[] = []
    @observable selectedRooms: BookingItem[] = []

    @action
    searchRooms () {
        axios.get(apiUrl + "/rooms", {
            params: {
                rno: this.rno,
                channel: this.channel,
                dateFrom: moment(this.checkIn).format("Y-MM-DD"),
                dateTo: moment(this.checkOut).format("Y-MM-DD")
            }
        }).then((response) => {
            runInAction(() => {
                this.rooms = response.data
                this.selectedRooms = []
            })
        }).catch((error) => {
            console.error(error)
            runInAction(() => {
                this.rooms = []
                this.selectedRooms = []
            })
        })
    }

    @action
    clearSearchRooms () {
        this.rooms = []
        this.selectedRooms = []
    }

    @action
    addToSelectedRooms (room: BookingItem) {
        this.selectedRooms.push(room)
    }

    @action
    removeFromSelectedRooms (room: BookingItem) {
        const index = this.selectedRooms.indexOf(room)

        this.selectedRooms.splice(index, 1)
    }

    @computed get
    selectedRoomsIds () {
        const ids = []
        for (const item of this.selectedRooms) {
            ids.push(item.id)
        }
        return ids
    }

    @computed get
    sumPrice () {
        let sum = 0
        for (const item of this.selectedRooms) {
            sum += item.price
        }
        return sum
    }

    @computed get
    payPrice () {
        return (this.sumPrice * this.feePercent / 100)
    }

    @computed get
    totalBeds () {
        let beds = 0
        for (const item of this.selectedRooms) {
            beds += item.beds
        }
        return beds
    }

    @computed get
    canBook () {
        return this.selectedRooms.length > 0 && this.totalBeds >= this.guests
    }

    @observable holderData: HolderData = {
        name: "",
        surname: "",
        email: "",
        phone: "",
        country: "",
        agree: false
    }

    @action
    setHolderData (data: Partial<HolderData>) {
        this.holderData = { ...this.holderData, ...data }

        this.canPay = this.isHolderDataValid()
    }

    isHolderDataValid = () => {
        if (this.holderData.name.length < 2) {
            return false
        }

        if (this.holderData.surname.length < 2) {
            return false
        }

        if (this.holderData.email.length < 2 && !this.holderData.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
            return false
        }

        if (!this.holderData.agree) {
            return false
        }

        return true
    }
}

export default AccomodationStore
